import { lumi } from '@/lib/lumi'
import { useState } from 'react'

export function useFileUpload() {
  const [uploading, setUploading] = useState(false)

  const uploadImage = async (file: File): Promise<string> => {
    setUploading(true)
    try {
      const results: any = await lumi.tools.file.upload([file])
      const uploaded = Array.isArray(results) ? results[0] : results
      const url = typeof uploaded === 'string' ? uploaded : uploaded?.url || uploaded?.fileUrl
      if (!url) throw new Error('Upload did not return a URL')
      return url
    } catch (error) {
      console.error('File upload failed:', error)
      throw error
    } finally {
      setUploading(false)
    }
  }

  return { uploadImage, uploading }
}
